import React from "react";

export const OnboardingCodeField = ({ value, onClick, focused }) => {
  return (
    <div className={`code-field${focused ? " focused" : ""}`} onClick={onClick}>
      {value}
    </div>
  );
};
